var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteIconBox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 32,
    height: 32,
    rx: 8,
    fill: "#EBEEF7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 24.5C11.1778 24.5 10.7593 24.3259 10.4111 23.9778C10.063 23.6296 9.88889 23.2111 9.88889 22.7222V11.1667H9V9.38889H13.4444V8.5H18.7778V9.38889H23.2222V11.1667H22.3333V22.7222C22.3333 23.2111 22.1593 23.6296 21.8111 23.9778C21.463 24.3259 21.0444 24.5 20.5556 24.5H11.6667ZM20.5556 11.1667H11.6667V22.7222H20.5556V11.1667ZM13.4444 20.9444H15.2222V12.9444H13.4444V20.9444ZM17 20.9444H18.7778V12.9444H17V20.9444Z",
    fill: "#D03C28"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIconBox);
export default __webpack_public_path__ + "static/media/delete_icon_box.1a3fc158b4cd81629c3c22f72c91f0c6.svg";
export { ForwardRef as ReactComponent };